// Centralized SEO constants and helpers.
// Always use the canonical www host so search engines consolidate signals.
export const SITE_URL = 'https://www.fordje.com';
export const SITE_NAME = 'Fordje';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const canonical = (path: string = '/'): string => {
  if (!path.startsWith('/')) path = `/${path}`;
  // Avoid trailing slash on non-root canonicals
  const stripped = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
  return `${SITE_URL}${stripped}`;
};
